import { Component } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {DataSecurityService} from 'src/app/services/data-security.service'
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';

@Component({
  selector: 'app-data-security',
  templateUrl: './data-security.component.html',
  styleUrls: ['./data-security.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DataSecurityComponent {
  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);
  Default:any
  showDataEncrypt:boolean=false;
  search:any={searchText:""}
  showDataEncryptPopup:boolean=false
  DataEncryptRegFg!:FormGroup
  columnsDataEncryptDisplay: string[] = ['keyStoreName','keyStoretype','keyType','keySize','keyNameAlias'];
  expandedElement!: any | null;
  totalElements:any=0
  action:any
  DataEncrypt:any=[]
  creationDate:any
  constructor(private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder,    private toastMsgService : ToastmsgService,
    private DataSecurityService:DataSecurityService, private userPrivileges: UserPrivilegeService,
    ){
      this.userPrivileges.userPrivilegesByModule('Data-Security').then((privileges:any) => {
        this.privilegesValue(privileges)
      })
      .catch((error:any) => {
      console.error(error); // Handle errors, if any
      });


      this.onClickDataEncrypt()
      this.dataFields()

    }
    privilegesView:any
    privilegesValue(privs:any){
     
      let privileges="";
    
    if(privs.includes('view')){
      this.privilegesView="VAMD"
    }else{
      this.privilegesView="AccessDenied"
    }
    
    }
    nextPage(event:PageEvent) {
    
      let page:any = {};
      page['page'] = event.pageIndex.toString();
      page['size'] = event.pageSize.toString();
      
      //this.getAllUser(page)
    
    }
  dataFields(){
    this.DataEncryptRegFg=this.fb.group({
      "keystoreType": ['',[Validators.required]],
      "keystoreName": ['',[Validators.required]],
      "keyAlias": ['',[Validators.required]],
      "keyType": ['',[Validators.required]],
      "keySize": ['',[Validators.required]],
      "keystorePwdPrefix":['',[Validators.required]],
      "keystorePwdSuffix":['',[Validators.required]],
      "keyPwdPrefix":['',[Validators.required]],
      "keyPwdSuffix":['',[Validators.required]],
      
    });
    
  }
  closePopup() {
    this.showDataEncryptPopup=false
    
    this.dataFields()
  }
  AddDataEncrypt(){
    

      this.DataSecurityService.saveEncryptor(this.DataEncryptRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Data Encryption Added Successfully!",msgTitle : "Success", msgType : "I"});
           
           this.showDataEncryptPopup=false
           this.dataFields();
           this.dataEncryptorlist()

          } else {
            const body : any = res.body;
            this.registerDataEncryptErrorMsg(res.status,body?.result);
          } 
  
        },error : (err) => {
  
          this.registerDataEncryptErrorMsg(err.status,err.error);
        }
      }
    )
  }
  
  registerDataEncryptErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Data Encryption",msgTitle : "Warning", msgType : "W"});
    } else {
  
      this.toastMsgService.setMsg({msg : "Failed to save Data Encryption",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
  dataEncryptorlist(){

    this.DataSecurityService
    .Encryptorlist()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.DataEncrypt=data
       
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
  backClick(){
    window.location.href="/app/settings"
      }
      rowdataEncryptorClick(element:any){
        this.creationDate=this.formatDate(element.creationDate)
        this.action="updateEncrypt"
        this.showDataEncryptPopup=true
        this.DataEncryptRegFg=this.fb.group({
          "keystoreType": [element?.ksType,[Validators.required]],
          "keystoreName": [element?.ksName,[Validators.required]],
          "keyAlias": [element?.keyAlias,[Validators.required]],
          "keyType": [element?.keyType,[Validators.required]],
          "keySize": [element?.keySize.toString(),[Validators.required]],
          "keystorePwdPrefix":['',[Validators.required]],
          "keystorePwdSuffix":['',[Validators.required]],
          "keyPwdPrefix":['',[Validators.required]],
          "keyPwdSuffix":['',[Validators.required]],
          
        });
        this.Default=element?.default
       
      }
      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }
     
      onAddDataEncrypt(){
        this.showDataEncryptPopup=true
        this.action="newEncrypt";
      }
      onClickDataEncrypt(){
        this.dataEncryptorlist()
      this.showDataEncrypt=true
      }

      UpdateStatus(){
        let request:any={}
      request["state"]="I"
      request["keystoreName"]=this.DataEncryptRegFg.value.keystoreName
      request["keyAlias"]=this.DataEncryptRegFg.value.keyAlias
        this.DataSecurityService.updateStatus(request)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "Data Encryption Delete Successfully!",msgTitle : "Success", msgType : "I"});
             
             this.showDataEncryptPopup=false
             this.dataFields();
             this.dataEncryptorlist()

            } else {
              const body : any = res.body;
              this.registerupdateStatusErrorMsg(res.status,body?.result);
            } 
    
          },error : (err) => {
    
            this.registerupdateStatusErrorMsg(err.status,err.error);
          }
        }
      )
    }
    
    registerupdateStatusErrorMsg(status : number,msg : string) {
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to Delete Data Encryption",msgTitle : "Warning", msgType : "W"});
      } else {
    
        this.toastMsgService.setMsg({msg : "Failed to Delete Data Encryption",msgTitle:  "Warning", msgType : "W"});
      } 
    }
    
    UpdateDefault(){
      let request:any={}
    request["defaultCrytor"]=this.Default
    request["keystoreName"]=this.DataEncryptRegFg.value.keystoreName
    request["keyAlias"]=this.DataEncryptRegFg.value.keyAlias
      this.DataSecurityService.updatedefault(request)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Data Encryption Update Successfully!",msgTitle : "Success", msgType : "I"});
           
           this.showDataEncryptPopup=false
           this.dataFields();
           this.dataEncryptorlist()

          } else {
            const body : any = res.body;
            this.registerupdateDefaultErrorMsg(res.status,body?.result);
          } 
  
        },error : (err) => {
          this.Default=!this.Default

          this.registerupdateDefaultErrorMsg(err.status,err.error);
        }
      }
    )
  }
  
  registerupdateDefaultErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to Update Data Encryption",msgTitle : "Warning", msgType : "W"});
    } else {
  
      this.toastMsgService.setMsg({msg : "Failed to Update Data Encryption",msgTitle:  "Warning", msgType : "W"});
    } 
  }
}
